import { render, staticRenderFns } from "./TestingOrganizationEdit.vue?vue&type=template&id=be36480c&scoped=true"
import script from "./TestingOrganizationEdit.vue?vue&type=script&lang=ts"
export * from "./TestingOrganizationEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be36480c",
  null
  
)

export default component.exports